import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";

export default function FilterAccordion({ children, label, helperText }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Box sx={{ borderTop: "1px solid rgb(241, 237, 230)" }}>
      <Button sx={styles.collapseButton} onClick={toggleOpen}>
        {label}

        <Box
          sx={styles.helperText}
        >
          <Box>{helperText}</Box>
          {isOpen ? (
            <KeyboardArrowDownOutlinedIcon />
          ) : (
            <KeyboardArrowUpOutlinedIcon />
          )}
        </Box>
      </Button>

      {isOpen && <Box padding="0px 8px 8px">{children}</Box>}
    </Box>
  );
}

const styles = {
  collapseButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "45px",
    width: "100%",
    fontFamily: "FustatSemiBold",
    fontSize: "14px",
    color: "#28382d",
    textTransform: "none",

    ":hover": {
      backgroundColor: "#ffffff",
    },
  },
  helperText: {
    color: "#98a29a",
    fontFamily: "FustatRegular",
    fontSize: "12px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  }
};
